/**
 *
 * InactiveTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import CircleIcon from 'assets/v2/CircleIcon';
import { COLORS } from 'theme';

import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.crayolaDark};
    background: ${COLORS.crayolaLight};
    border-color: ${COLORS.crayolaDark};

    &&& .MuiChip-icon path {
      fill: ${COLORS.crayola};
    }
  }
`;

const InactiveTag = (props) => (
  <StyledTag label="Inactive" icon={<CircleIcon />} {...props} />
);

export default memo(InactiveTag);
